import React, { type ButtonHTMLAttributes } from 'react';
import { Box, TextLinkButton } from 'braid-design-system';

import { linkPropsWithKeyboardNavigation } from '../../../utils/buildHandleEnterAndSpaceKeyPress';

interface TextButton extends ButtonHTMLAttributes<HTMLButtonElement> {
  onClick: () => void;
}

const TextButton = ({ onClick, children, ...restProps }: TextButton) => {
  const buttonProps = {
    ...linkPropsWithKeyboardNavigation(onClick),
  };

  return (
    <Box {...restProps}>
      <TextLinkButton {...buttonProps}>{children}</TextLinkButton>
    </Box>
  );
};

export default TextButton;
